(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ots-supplement-assessment"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var API_BASE = '/apps/ots-assessment';

    document.querySelectorAll('.ots-assessment').forEach(function (root) {
      if (root.dataset.otsInit) return;
      root.dataset.otsInit = 'true';
      initAssessment(root);
    });

    function initAssessment(root) {
      var state = { conditions: [], selectedDrugs: [] };

      var backdrop = root.querySelector('.ots-backdrop');
      var formPanel = root.querySelector('[data-ots-panel="form"]');
      var resultsPanel = root.querySelector('[data-ots-panel="results"]');
      var openConditionsBtn = root.querySelector('[data-ots-open-conditions]');
      var conditionsDialog = root.querySelector('[data-ots-conditions-dialog]');
      var conditionsList = root.querySelector('[data-ots-conditions-list]');
      var conditionPills = root.querySelector('[data-ots-condition-pills]');
      var applyConditionsBtn = root.querySelector('[data-ots-apply-conditions]');
      var cancelConditionsBtn = root.querySelector('[data-ots-cancel-conditions]');
      var drugInput = root.querySelector('[data-ots-drug-input]');
      var drugSuggestions = root.querySelector('[data-ots-drug-suggestions]');
      var drugError = root.querySelector('[data-ots-drug-error]');
      var drugPills = root.querySelector('[data-ots-drug-pills]');
      var submitBtn = root.querySelector('[data-ots-submit]');
      var retakeBtn = root.querySelector('[data-ots-retake]');
      var topResults = root.querySelector('[data-ots-top-results]');
      var additionalGroup = root.querySelector('[data-ots-additional]');
      var additionalResults = root.querySelector('[data-ots-additional-results]');
      var altDialog = root.querySelector('[data-ots-alt-dialog]');
      var altList = root.querySelector('[data-ots-alt-list]');
      var noticeDialog = root.querySelector('[data-ots-notice-dialog]');
      var noticeMessage = root.querySelector('[data-ots-notice-message]');
      var noticeCancel = root.querySelector('[data-ots-notice-cancel]');
      var noticeConfirm = root.querySelector('[data-ots-notice-confirm]');

      var selectedGender = null;
      root.querySelectorAll('input[name="ots-gender"]').forEach(function (input) {
        input.addEventListener('change', function () {
          selectedGender = input.value;
          openConditionsBtn.disabled = false;
        });
      });

      fetch(API_BASE + '/medical-conditions')
        .then(function (r) { return r.json(); })
        .then(function (conditions) {
          state.conditions = conditions;
          conditionsList.innerHTML = conditions.map(function (c) {
            return '<label class="ots-condition-option" data-gender="' + c.gender + '">' +
              '<input type="checkbox" value="' + c.uniqueCode + '" data-label="' + escapeHtml(c.medicalConditionName) + '">' +
              '<span>' + escapeHtml(c.medicalConditionName) + '</span>' +
              '</label>';
          }).join('');
        })
        .catch(function (err) { conditionsList.innerHTML = '<p>Unable to load conditions.</p>'; console.error(err); });

      openConditionsBtn.addEventListener('click', function () {
        conditionsList.querySelectorAll('.ots-condition-option').forEach(function (opt) {
          var g = opt.getAttribute('data-gender');
          opt.hidden = !(g === 'B' || g === selectedGender);
        });
        conditionsDialog.showModal();
      });

      cancelConditionsBtn.addEventListener('click', function () { conditionsDialog.close(); });

      applyConditionsBtn.addEventListener('click', function () {
        conditionsDialog.close();
        var picked = Array.from(conditionsList.querySelectorAll('input:checked'));
        conditionPills.innerHTML = picked.map(function (input) {
          return pillHtml(input.value, input.dataset.label);
        }).join('');
      });

      conditionPills.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-remove]');
        if (!btn) return;
        var code = btn.getAttribute('data-remove');
        var checkbox = conditionsList.querySelector('input[value="' + cssEscape(code) + '"]');
        if (checkbox) checkbox.checked = false;
        btn.closest('.ots-pill').remove();
      });

      var drugDebounce;
      var drugErrorTimeout;

      drugInput.addEventListener('input', function () {
        hideDrugError();
        clearTimeout(drugDebounce);
        var term = drugInput.value.trim();
        if (!term) { drugSuggestions.hidden = true; return; }
        drugDebounce = setTimeout(function () {
          fetch(API_BASE + '/drugs?name=' + encodeURIComponent(term))
            .then(function (r) { return r.json(); })
            .then(function (names) {
              drugSuggestions.innerHTML = names.map(function (name) {
                return '<li tabindex="0">' + escapeHtml(name) + '</li>';
              }).join('');
              drugSuggestions.hidden = names.length === 0;
            })
            .catch(function (err) { console.error(err); });
        }, 250);
      });

      // Only a click (or Enter/keyboard select) on an actual suggestion adds a
      // medication -- typed text alone is never accepted, so users can't submit
      // a medication that was never matched against the real drug list.
      drugSuggestions.addEventListener('click', function (e) {
        var li = e.target.closest('li');
        if (!li) return;
        addDrug(li.textContent);
      });

      drugInput.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();

        var visibleSuggestions = drugSuggestions.hidden ? [] : Array.from(drugSuggestions.querySelectorAll('li'));
        if (visibleSuggestions.length === 1) {
          addDrug(visibleSuggestions[0].textContent);
        } else if (drugInput.value.trim()) {
          rejectDrugEntry();
        }
      });

      drugInput.addEventListener('blur', function () {
        // Delay so a click on a suggestion (which also blurs the input) still
        // registers via the click handler above before we clear stray text.
        setTimeout(function () {
          if (drugInput.value.trim()) rejectDrugEntry();
        }, 200);
      });

      document.addEventListener('click', function (e) {
        if (!drugInput.contains(e.target) && !drugSuggestions.contains(e.target)) {
          drugSuggestions.hidden = true;
        }
      });

      function addDrug(name) {
        if (state.selectedDrugs.indexOf(name) === -1) {
          state.selectedDrugs.push(name);
          drugPills.insertAdjacentHTML('beforeend', pillHtml(name, name));
        }
        drugInput.value = '';
        drugSuggestions.hidden = true;
        hideDrugError();
      }

      function rejectDrugEntry() {
        drugInput.value = '';
        drugSuggestions.hidden = true;
        drugError.hidden = false;
        clearTimeout(drugErrorTimeout);
        drugErrorTimeout = setTimeout(hideDrugError, 4000);
      }

      function hideDrugError() {
        drugError.hidden = true;
        clearTimeout(drugErrorTimeout);
      }

      drugPills.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-remove]');
        if (!btn) return;
        var name = btn.getAttribute('data-remove');
        state.selectedDrugs = state.selectedDrugs.filter(function (d) { return d !== name; });
        btn.closest('.ots-pill').remove();
      });

      submitBtn.addEventListener('click', function () {
        var medCons = Array.from(conditionsList.querySelectorAll('input:checked')).map(function (i) { return i.value; });
        var drugs = state.selectedDrugs.slice();

        if (!medCons.length && !drugs.length) {
          showNotice('Please select at least one medical condition.<br>Or enter at least one medication.', false);
          return;
        }

        if (!medCons.length || !drugs.length) {
          showNotice("You haven't completed both sections.<br>Do you want to continue?", true, function () {
            loadRecommendations(medCons, drugs);
          });
          return;
        }

        loadRecommendations(medCons, drugs);
      });

      // Mirrors the legacy app's behavior: block only when both sections are
      // empty; ask for confirmation when just one is filled in.
      var noticeConfirmHandler = null;

      noticeCancel.addEventListener('click', function () { noticeDialog.close(); });

      function showNotice(messageHtml, askConfirm, onConfirm) {
        noticeMessage.innerHTML = messageHtml;
        noticeCancel.hidden = !askConfirm;
        noticeConfirm.textContent = askConfirm ? 'Continue' : 'OK';

        if (noticeConfirmHandler) noticeConfirm.removeEventListener('click', noticeConfirmHandler);
        noticeConfirmHandler = function () {
          if (askConfirm && typeof onConfirm === 'function') onConfirm();
        };
        noticeConfirm.addEventListener('click', noticeConfirmHandler);

        noticeDialog.showModal();
      }

      retakeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        resultsPanel.hidden = true;
        retakeBtn.hidden = true;
        formPanel.hidden = false;
        conditionPills.innerHTML = '';
        drugPills.innerHTML = '';
        state.selectedDrugs = [];
        conditionsList.querySelectorAll('input').forEach(function (i) { i.checked = false; });
        formPanel.scrollIntoView({ behavior: 'smooth' });
      });

      function toggleLoader(show) { backdrop.hidden = !show; }

      function loadRecommendations(medCons, drugs) {
        toggleLoader(true);
        var url = API_BASE + "/supplements?medCons='" + medCons.join(',') + "'&drugs='" + drugs.join(',') + "'";

        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (payload) { renderResults(payload.data || []); })
          .catch(function (err) { console.error('Failed to load recommendations', err); })
          .finally(function () { toggleLoader(false); });
      }

      // All card data (image, price, description) already comes back enriched
      // from /proxy/supplements -- no per-item network round trip needed here.
      function renderResults(items) {
        topResults.innerHTML = '';
        additionalResults.innerHTML = '';

        if (!items.length) return;

        items.slice(0, 5).forEach(function (item) { topResults.appendChild(buildCard(item)); });
        items.slice(5).forEach(function (item) { additionalResults.appendChild(buildCard(item)); });

        additionalGroup.hidden = items.length <= 5;
        formPanel.hidden = true;
        resultsPanel.hidden = false;
        retakeBtn.hidden = false;
        resultsPanel.scrollIntoView({ behavior: 'smooth' });
      }

      function buildCard(item) {
        return buildProductCard(item, { showAlternatesLink: true });
      }

      // Shared by both the main results grid and the "View alternatives" popup,
      // so alternates get the same real image/price/description/add-to-cart as
      // top-level recommendations, not just a bare name.
      function buildProductCard(item, options) {
        options = options || {};
        var card = document.createElement('div');
        var soldOut = item.variantId && item.isAvailable === false;
        card.className = 'ots-card' + (soldOut ? ' ots-card--sold-out' : '');

        var altBtn = (options.showAlternatesLink && item.lstAlternate && item.lstAlternate.length)
          ? '<button type="button" class="ots-card__alt">View alternatives</button>'
          : '';

        var purchaseControl;
        if (!item.variantId) {
          purchaseControl = '';
        } else if (soldOut) {
          purchaseControl = '<span class="ots-card__sold-out-label">Sold Out</span>';
        } else {
          purchaseControl = '<button type="button" class="ots-card__add-to-cart" data-variant-id="' + item.variantId + '">Add to cart</button>';
        }

        card.innerHTML =
          '<div class="ots-card__image-wrap">' +
            '<img class="ots-card__image" src="' + (item.imageUrl || '') + '" loading="lazy" alt="' + escapeHtml(item.suppName || '') + '">' +
            (soldOut ? '<span class="ots-card__sold-out-badge">Sold Out</span>' : '') +
          '</div>' +
          '<div>' +
            '<div class="ots-card__title">' + escapeHtml(item.suppName || '') + '</div>' +
            '<div class="ots-card__desc">' + (item.shortDescription || '') + '</div>' +
            altBtn +
          '</div>' +
          '<div class="ots-card__purchase">' +
            '<div class="ots-card__price">' + (item.price || '') + '</div>' +
            '<div class="ots-card__actions">' +
              '<a class="ots-card__view" href="' + (item.productUrl || item.seName || '#') + '" target="_blank" rel="noopener">View</a>' +
              purchaseControl +
            '</div>' +
          '</div>';

        var altButtonEl = card.querySelector('.ots-card__alt');
        if (altButtonEl) {
          altButtonEl.addEventListener('click', function () { showAlternates(item.lstAlternate); });
        }

        var addToCartEl = card.querySelector('.ots-card__add-to-cart');
        if (addToCartEl) {
          addToCartEl.addEventListener('click', function () { addToCart(addToCartEl); });
        }

        return card;
      }

      function addToCart(button) {
        var variantId = button.getAttribute('data-variant-id');
        button.dataset.state = 'loading';
        var originalText = button.textContent;
        button.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'Add to cart failed'); });
            return r.json();
          })
          .then(function () {
            button.dataset.state = 'added';
            button.textContent = 'Added';
            refreshCartCount();
            setTimeout(function () {
              button.dataset.state = '';
              button.textContent = originalText;
            }, 2500);
          })
          .catch(function (err) {
            console.error('Add to cart failed', err);
            button.dataset.state = '';
            button.textContent = originalText;
            window.alert('Sorry, that item could not be added to your cart.');
          });
      }

      // The theme's own cart badge is a plain <span data-js-cart-count> in the
      // header (confirmed from the theme's own source) -- update it directly
      // rather than relying on a proprietary cart-refresh event we can't see.
      function refreshCartCount() {
        fetch('/cart.js', { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          })
          .catch(function (err) { console.error('Failed to refresh cart count', err); });

        refreshQuickCart();
      }

      // The quick-cart popup (id="shopify-section-quick-cart") is rendered server-side
      // ONCE at page load with whatever the cart looked like then. Since our Add to
      // cart bypasses the theme's own product-form submit flow, the theme never knows
      // to re-render it -- so without this, opening the popup after adding an item here
      // shows stale (or empty) contents until a real page navigation happens. Re-fetch
      // the section via the Section Rendering API and swap in the fresh markup instead.
      function refreshQuickCart() {
        // cache: 'no-store' is required here -- this response has no explicit
        // Cache-Control header (only Cloudflare's edge-only cdn-cache-control),
        // so Chromium and Firefox apply different heuristics for whether to
        // reuse a cached copy of this exact URL. Without forcing a fresh
        // request, Chrome/Edge were serving the stale page-load-time response.
        fetch(window.location.pathname + '?section_id=quick-cart', { cache: 'no-store' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var current = document.getElementById('shopify-section-quick-cart');
            if (current && html) current.outerHTML = html;
          })
          .catch(function (err) { console.error('Failed to refresh quick cart', err); });
      }

      function showAlternates(alternates) {
        altList.innerHTML = '';
        alternates.forEach(function (a) {
          altList.appendChild(buildProductCard(a, { showAlternatesLink: false }));
        });
        altDialog.showModal();
      }

      function pillHtml(value, label) {
        return '<span class="ots-pill">' + escapeHtml(label) +
          '<button type="button" data-remove="' + escapeHtml(value) + '" aria-label="Remove">&times;</button></span>';
      }

      function escapeHtml(str) {
        return String(str).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function cssEscape(str) {
        return String(str).replace(/["\\]/g, '\\$&');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
